import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const viewAllIcon = createIconDefinition(
  'viewAllIcon',
  `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 2.5C3.61929 2.5 2.5 3.61929 2.5 5V15C2.5 16.3807 3.61929 17.5 5 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V5C17.5 3.61929 16.3807 2.5 15 2.5H5ZM4.16667 11.3892H15.8333V8.61084H4.16667V11.3892ZM15.8333 6.94417V4.16667H4.16667V6.94417H15.8333ZM4.16667 13.0558H15.8333V15.8333H4.16667V13.0558Z"/>
</svg>`,
);
